// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"d3018547","467":"69ac348b","674":"f4975cd3","722":"28079ffb","896":"6886eebb","947":"5bd98b0f"}[chunkId] + ".chunk.js";
};